import { Routes, Route, Navigate } from 'react-router-dom'
import FreightForwarderDashboard from '../pages/dashboard/FreightForwarderDashboard'
import OpportunitiesPage from '../pages/freight-forwarder/OpportunitiesPage'
import MyOffersPage from '../pages/freight-forwarder/MyOffersPage'
import NewOfferPage from '../pages/freight-forwarder/NewOfferPage'
import ShipmentsPage from '../pages/freight-forwarder/ShipmentsPage'
import PerformancePage from '../pages/freight-forwarder/PerformancePage'
import SettingsPage from '../pages/freight-forwarder/SettingsPage'
import InvitesPage from '../pages/freight-forwarder/InvitesPage'
import LostOffersPage from '../pages/freight-forwarder/LostOffersPage'
import OrderDetailsPage from '../pages/freight-forwarder/OrderDetailsPage'
import NotificationsPage from '../pages/NotificationsPage'
import QuoteViewPage from '../pages/shared/QuoteViewPage'

export default function FreightForwarderRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<FreightForwarderDashboard />} />

      {/* Opportunities */}
      <Route path="/opportunities" element={<OpportunitiesPage />} />
      <Route path="/opportunities/:id" element={<NewOfferPage />} />
      <Route path="/opportunities/:id/new-offer" element={<NewOfferPage />} />

      {/* My Offers */}
      <Route path="/offers" element={<MyOffersPage />} />
      <Route path="/my-offers" element={<MyOffersPage />} />
      <Route path="/lost-offers" element={<LostOffersPage />} />
      <Route path="/offers/:id" element={<NewOfferPage />} />
      <Route path="/offers/:id/edit" element={<NewOfferPage />} />

      {/* Invites */}
      <Route path="/invites" element={<InvitesPage />} />

      {/* Orders */}
      <Route path="/orders/:id" element={<OrderDetailsPage />} />

      {/* Quote View */}
      <Route path="/quotes/:id/view" element={<QuoteViewPage />} />

      {/* Other Pages */}
      <Route path="/shipments" element={<ShipmentsPage />} />
      <Route path="/performance" element={<PerformancePage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />

      {/* Redirect /freight-forwarder to /freight-forwarder/dashboard */}
      <Route path="/" element={<Navigate to="/freight-forwarder/dashboard" replace />} />

      {/* 404 within freight-forwarder routes */}
      <Route path="*" element={<div>Página não encontrada</div>} />
    </Routes>
  )
}
